// Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields -- Change wait date section.
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
// Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
// akhila 12/21/2022 2700271704 changed labels
// Ashraf 01/03/2023 2700271704 renamed disposition to status
// Raghu 02/28/2023 2700271704 added new class to input fields
// suresh peddavoora 04/06/2023 2700271704 fields alignment fixes
// Prakash 13/04/2023 2700271704 remove margin top
// Prakash 10-05-23 2700271704 add theme class name.
// Dipip-pds 10/20/2023 2700271704 fixed prepopulate issue of wait Date
// Sohel 11/30/2023 2700271704 data calculation field disable css modified and radio button on data calculation popup open

import {
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  makeStyles,
} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch} from 'react-redux';
import {NumberFormatterPostiveNegavtive} from '../../../../../components/UserDefinedForm/AppTextInputComponents';
import {
  handleSearchRuleGroupFieldData,
} from '../../../../../redux/reducers/EventTactics/EventTactics';
import DateFnsUtils from '@date-io/date-fns';

const ChangeWaitDate = (props) => {
  const useStyles = makeStyles((theme) => ({
    communicationRadioButtons: {
      '& .MuiFormControlLabel-root': {
        marginBottom: '20px',
      },
    },
    communicationCheckBoxes: {
      'padding': '5px 10px',
      '& .MuiFormControl-marginDense': {
        margin: '0 !important',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    communicationRadioButtonsLabel: {
      'padding': '5px 10px',
      '& .MuiFormLabel-root': {
        fontWeight: '600',
        marginBottom: '0',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    groupWrapper: {
      '& .MuiFormGroup-root': {
        flexWrap: 'nowrap !important',
      },
      '& .MuiFormControlLabel-root': {
        marginRight: '3rem !important',
        [theme.breakpoints.down('sm')]: {
          marginRight: '1rem !important',
        },
      },
    },
  }));

  const dispatch = useDispatch();
  const applyToOptions = [{key: 'R', value: 'R - Route'}];
  const {
    setShowSearch,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    handleBlur,
  } = props;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const styles = useStyles();
  const label = ['Wait Date', 'Fixed Wait Date', 'Data Calculation'];

  return (
    <>
      <Grid item xs={4} sm={4} className={`form-group ${classes.selectField}`}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            placeholder="Select ApplyTo"
            onBlur={handleBlur}
            touched={touched?.applyTo}
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {applyToOptions.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors.applyTo && errors.applyTo}</FormHelperText>
      </Grid>
      {/* <Grid item xs={4} sm={4} className={`form-group `}>
        <TextField
          margin="dense"
          variant="outlined"
          className={` ${classes.labelName}`}
          placeholder={`Enter Wait Days`}
          label={"Wait Days"}
          // InputLabelProps={{
          //   shrink: true,
          // }}
          InputProps={{
            startAdornment: <InputAdornment position="start">Today +</InputAdornment>,
            inputComponent: NumberFormatterPostiveNegavtive,
          }}
          name={"waitDays"}
          value={values?.waitDays}
          onChange={(e) => {
            setFieldValue("waitDays", e.target.value);
          }}
          fullWidth
          onBlur={handleBlur}
          touched={touched.waitDays}
          error={touched?.waitDays && errors.waitDays && errors.waitDays}
        />
      </Grid>
      <Grid item xs={4} sm={4} className={`form-group`}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            className={` ${classes.labelName}`}
            name={"waitDate"}
            format="MM/dd/yyyy"
            placeholder="MM/DD/YYYY"
            label={"Wait Date"}
            fullWidth
            value={values?.waitDate || null}
            inputVariant="outlined"
            margin="dense"
            onChange={(date) => {
              setFieldValue("waitDate", date);
            }}
            // InputLabelProps={{
            //   shrink: true,
            // }}
            autoOk
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={4} sm={4} className={`form-group`}>
        <TextField
          margin="dense"
          variant="outlined"
          placeholder={`Enter Wait Date Data Calculation`}
          className={`label-overflow ${classes.labelName}`}
          label={"Wait Date Data Calculation"}
          disabled
          // InputLabelProps={{
          //   shrink: true,
          // }}
          name={"ruleGroup"}
          value={values?.ruleGroup}
          onChange={(e) => {
            setFieldValue("ruleGroup", e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search
                  className={` ${classes.iconSearch}`}
                  onClick={() => {
                    dispatch(
                      handleSearchRuleGroupFieldData({
                        status: true,
                        fieldName: "ruleGroup",
                        setFieldValue: setFieldValue,
                        setShowSearch: setShowSearch,
                        returnType: "Date",
                      })
                    );
                    setShowSearch(true);
                  }}
                  size="sm"
                />
                <Clear
                  className={` ${classes.iconSearch}`}
                  onClick={(e) => setFieldValue("ruleGroup", "")}
                />
              </InputAdornment>
            ),
          }}
          fullWidth
          onBlur={handleBlur}
          touched={touched.ruleGroup}
          error={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
        />
      </Grid> */}
      <Grid container spacing={4} className="m-0 new-standard-textfields">
        <Grid item xs={12} sm={12}>
          <div className={`${styles.groupWrapper} d-flex`}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="updateDateBy"
                aria-label="gender"
                value={values?.updateDateBy}
                defaultValue={'Wait Date'}
                onChange={(e) => {
                  setFieldValue('updateDateBy', e.target.value);
                  setFieldValue('waitDays', '');
                  setFieldValue('waitDate', null);
                  setFieldValue('ruleGroup', '');
                  if (e.target.value === 'Data Calculation')
                  {
                    dispatch(
                      handleSearchRuleGroupFieldData({
                        status: true,
                        fieldName: 'ruleGroup',
                        setFieldValue: setFieldValue,
                        setShowSearch: setShowSearch,
                        returnType: 'Date',
                      }),
                    );
                    setShowSearch(true);
                  } 
                }}
              >
                {label.map((item, i) => (
                  <FormControlLabel
                    key={i}
                    value={item}
                    control={<Radio name={item} />}
                    label={item}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            {values?.updateDateBy === 'Wait Date' ? (
              <Grid item xs={4} sm={4} className={`form-group `}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  className={` ${classes.labelName}`}
                  placeholder={`Enter Wait Date`}
                  label={'Wait Date'}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Today +</InputAdornment>,
                    inputComponent: NumberFormatterPostiveNegavtive,
                  }}
                  name={'waitDays'}
                  value={values?.waitDays}
                  onChange={(e) => {
                    setFieldValue('waitDays', e.target.value);
                  }}
                  fullWidth
                  onBlur={handleBlur}
                  touched={touched.waitDays}
                  error={touched?.waitDays && errors.waitDays && errors.waitDays}
                />
              </Grid>
            ) : values?.updateDateBy === 'Fixed Wait Date' ? (
              <Grid item xs={4} sm={4} className={`form-group`}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={` ${classes.labelName}`}
                    name={'waitDate'}
                    format="MM/dd/yyyy"
                    placeholder="MM/DD/YYYY"
                    label={'Fixed Wait Date'}
                    fullWidth
                    value={values?.waitDate || null}
                    inputVariant="outlined"
                    margin="dense"
                    onChange={(date) => {
                      setFieldValue('waitDate', date);
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            ) : values?.updateDateBy === 'Data Calculation' ? (
              <Grid item xs={4} sm={4} className={`form-group wait-date-disable-field`}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder={`Enter Wait Date Data Calculation`}
                  className={`label-overflow ${classes.labelName}`}
                  label={'Wait Date Data Calculation'}
                  disabled
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  name={'ruleGroup'}
                  value={values?.ruleGroup?.dataCalculation ? values?.ruleGroup?.dataCalculation :values?.ruleGroup ? values?.ruleGroup : ''}
                  onChange={(e) => {
                    setFieldValue('ruleGroup', e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search
                          className={` ${classes.iconSearch}`}
                          onClick={() => {
                            dispatch(
                              handleSearchRuleGroupFieldData({
                                status: true,
                                fieldName: 'ruleGroup',
                                setFieldValue: setFieldValue,
                                setShowSearch: setShowSearch,
                                returnType: 'Date',
                              }),
                            );
                            setShowSearch(true);
                          }}
                          size="sm"
                        />
                        <Clear
                          className={` ${classes.iconSearch}`}
                          onClick={(e) => setFieldValue('ruleGroup', '')}
                        />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  onBlur={handleBlur}
                  touched={touched.ruleGroup}
                  error={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
                />
              </Grid>
            ) : null}

          </div>

        </Grid>
      </Grid>
    </>
  );
};

export default ChangeWaitDate;
